// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progreccBox[data-v-81a98d62]  .el-progress{top:-4px}[data-v-81a98d62] .el-icon-close{display:none}.active[data-v-81a98d62]{cursor:not-allowed!important}[data-v-81a98d62] .active em{color:#adadad!important}.disabledIntro[data-v-81a98d62]{margin-top:10px;cursor:not-allowed}.disabledIntro .el-icon-lock[data-v-81a98d62]{color:#c0c4cc}.disabledIntro span[data-v-81a98d62]{color:#006dcc}", ""]);
// Exports
module.exports = exports;
